module.exports = __webpack_public_path__ + "static/img/bg-id.f63d5155.png";